"use client";
import "@/tailwind-styles/tailwind.global.css";

import { getAssetImage } from "@/service/image/asset";
import { trans } from "@/service/i18n/i18n";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { SuperLink as Link } from "@/components/common/super-link";
import { ServerUpdatingPage } from "@/components/common/server-is-updating";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const [serverDown, setServerDown] = useState(false);

  useEffect(() => {
    (async () => {
      const response = await fetch("/shared-client-api/status");
      if (!response.ok) {
        setServerDown(true);
      }
    })();
  }, []);

  const error500 = (
    <div className="flex flex-col items-center justify-center gap-8 py-16 text-center">
      <img
        src={getAssetImage("/error/500.png")}
        alt="500"
        className="h-auto w-64 md:w-96"
      />
      <h1 className="text-muted-foreground text-3xl font-semibold tracking-tight md:text-4xl">
        {trans("error.500")}
      </h1>
      <div className="flex flex-wrap items-center justify-center gap-4">
        <Button variant="blue" asChild>
          <Link href={"/"}>{trans("error.home")}</Link>
        </Button>
      </div>
    </div>
  );
  return (
    <html lang={"pl"}>
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#5024FF" />

        <meta
          name="facebook-domain-verification"
          content="5cdyxg7wix6tt2hhqd9wsmw4eml4wy"
        />
        <link rel={"stylesheet"} href={"https://cdn.remedium.md/destyle.css"} />
        <link rel="icon" href={getAssetImage("/favicon.ico")} sizes="any" />
        <link rel="apple-touch-icon" href={getAssetImage("/favicon.png")} />
      </head>
      <body>{serverDown ? <ServerUpdatingPage /> : error500}</body>
    </html>
  );
}
